import ProfileFromPartnerCategory from './ProfileFromPartnerCategory';
export default ProfileFromPartnerCategory;


// WEBPACK FOOTER //
// ./src/containers/dashboard-spl/profileFromPartnerCategory/index.js